/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const IndividualExamStatusDto = {
    Draft: 'DRAFT',
    Started: 'STARTED',
    Passed: 'PASSED',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED'
} as const;

export type IndividualExamStatusDto = typeof IndividualExamStatusDto[keyof typeof IndividualExamStatusDto];



